export const meleeStats: Record<string, number | string> = {
  'Range (meters)': '0-8',
  'Primary Fire Front Stab': 50,
  'Primary Fire Back Stab': 100,
  'Alt Fire Front Stab': 75,
  'Alt Fire Back Stab': 150
};

export const meleeIcon: string = 'https://media.valorant-api.com/weapons/2f59173c-4bed-b6c3-2191-dea9b58be9c7/displayicon.png';
